export default __webpack_public_path__ + "static/media/Foto galerija 4.cf7a0798.jpg";